import React from 'react';

import {Link} from 'shells/link/link';
import type {Level} from 'shells/status-badge/status-badge';
import {Body} from 'shells/typography/body';

import type {AnalyticsStatus, CopyableLinkVariant} from './types';

export function getAnalyticsStatusBadgeInfo(status: AnalyticsStatus): {
    level: Level;
    text: string;
} {
    switch (status) {
        case 'NEVER_CONFIGURED':
            return {level: 'info--grey', text: 'Not enabled'};
        case 'CONFIGURED':
            return {level: 'success', text: 'Enabled'};
        case 'NOT_WORKING':
            return {level: 'warning', text: 'Not working'};
        default:
            return {level: 'info--grey', text: 'Not enabled'};
    }
}

export function getCopyableWrapperInfo(type: CopyableLinkVariant) {
    switch (type) {
        case 'LINK':
            return {
                header: 'Plugin',
                label: (
                    <Body size='small' color='dark'>
                        Visit this link to install the{' '}
                        <Link
                            href='https://wordpress.org/plugins/nutshell-analytics/'
                            variant='primary'
                            newTab={true}
                            size='small'
                        >
                            WordPress plugin
                        </Link>{' '}
                        on your site.
                    </Body>
                ),
                name: 'wordPressSnippet',
            };
        case 'ACCOUNT_ID':
            return {
                header: 'Account ID',
                label: (
                    <Body size='small' color='dark'>
                        Copy and paste this account ID into the WordPress plugin settings.
                    </Body>
                ),
                name: 'wordpressSnippet',
            };
        case 'TOKEN':
            return {
                header: 'Token',
                label: (
                    <Body size='small' color='dark'>
                        Copy and paste this token into the WordPress plugin settings.
                    </Body>
                ),
                name: 'wordpressSnippet',
            };
        case 'DOMAIN':
            return {
                header: 'Custom domain',
                label: (
                    <Body size='small' color='dark'>
                        Copy and paste your custom domain into the WordPress plugin settings.
                    </Body>
                ),
                name: 'wordpressSnippet',
            };
        default:
            return null;
    }
}
